import "./style.scss";

import StyledButton from "components/shared/StyledButton";
import { useTranslation } from "react-i18next";

type TProps = {
    handleSubmit: () => void;
    userData: Record<string, any>;
};
const DAS2Export = ({ handleSubmit, userData }: TProps) => {
    const [t] = useTranslation();

    return (
        <>
            <div className="das2-export">
                <div className="das2-export-input">
                    <span style={{ marginBottom: "4px" }}>
                        Vous êtes sur le point d{"'"}inviter <u>{userData.email}</u> sur l{"'"}entreprise{" "}
                        <u>{userData.companyName}</u>.
                        <br />
                        <br />
                        Confirmez-vous cette action ?
                    </span>
                </div>
                <StyledButton buttonType="primary" fullWidth onClick={() => handleSubmit()}>
                    Oui, donner accès
                </StyledButton>
            </div>
        </>
    );
};

export default DAS2Export;
